import { SET_VIDEO_CATEGORIES } from 'store/types/video-catergory';

const initialState = {
  videoCategories: [],
};

const videoCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VIDEO_CATEGORIES:
      return {
        ...state,
        videoCategories: action?.payload,
      };
    default:
      return state;
  }
};

export default videoCategoryReducer;
